import en from './en.json'
import it from './it.json'

export const sessionsTranslations = {
	en,
	it
} as const
